# Takes attributes for:
#   css-classes: String; a space-delimited list of CSS classes to apply to SVG element
#   icon-name: String (optional); hashtag-prefaced icon name from icon-map (e.g. '#icon-alert')
#   aria-labelledby: String
#   aria-hidden: Boolean (optional; default: false)
# Ex: <amount-icon
#       css-classes="icon close"
#       icon-name="#icon-close"
#       aria-labelledby="close"
#       aria-hidden="true" (defaults to false)
#     ></amount-icon>

angular.module("avant.customer_applications.directives").directive "amountIcon", () ->
  restrict: 'E'
  scope:
    ariaHidden: '@'
    ariaLabelledby: '@'
    cssClasses: '@'
    icon: '@iconName'
    iconId: '@'
  template: '''
    <svg role="img"
      id="{{ iconId }}"
      class="{{ cssClasses }}"
      aria-labelledby="{{ ariaLabelledby }}"
      aria-hidden="{{ ariaHidden }}"
      focusable="{{ focusable }}"
    >
      <use xlink:href="{{ icon }}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
    </svg>
  '''
  link: (scope) ->
    # In the event that the boolean is stringified
    if typeof scope.ariaHidden == "string" then scope.ariaHidden = (scope.ariaHidden == "true")
    # To prevent IE-11 from tabbing onto unactionable SVG icons
    scope.focusable = !scope.ariaHidden
